import { render, staticRenderFns } from "./inactiveProducts.vue?vue&type=template&id=076dcd06"
import script from "./inactiveProducts.vue?vue&type=script&lang=js"
export * from "./inactiveProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports